export const DEFAULT_PAGE_LIMIT = 10;
export const getRowsPerPage = (count, pageLimit = DEFAULT_PAGE_LIMIT) => count > pageLimit ? pageLimit : Number.POSITIVE_INFINITY;